import ReCAPTCHA from 'react-google-recaptcha';
import { Paragraph, StackedColumn } from '../../../core';
import { ReCaptchaState, ReCaptchaValidator } from '../../reCaptchaValidator';

interface SessionTimeoutPresenterProps {
  reCaptchaRef: React.RefObject<ReCAPTCHA>;
  reCaptchaState: ReCaptchaState;
  onReCaptchaChange: () => void;
}

const SessionTimeoutPresenter: React.FC<SessionTimeoutPresenterProps> = (
  props: SessionTimeoutPresenterProps
) => {
  props;
  return (
    <StackedColumn>
      <Paragraph text="Privacy is essential, and you've been gone a while." />
      <Paragraph text="Please confirm you're still with us and would like to continue scheduling online." />
      <ReCaptchaValidator
        reCaptchaRef={props.reCaptchaRef}
        reCaptchaState={props.reCaptchaState}
        onReCaptchaChange={props.onReCaptchaChange}
      />
    </StackedColumn>
  );
};

export default SessionTimeoutPresenter;
